module.exports = __webpack_public_path__ + "img/20200801_161404.13e50420.jpg";